import { defineMessages } from 'react-intl';

export default defineMessages({
  body: {
    id: 'frontbucket.repository.source.discardChangesDialog.body',
    description:
      'Body text in a confirmation dialog explaining that any changes just made to a file will be lost upon clicking the "Confirm" button',
    defaultMessage:
      "You've made some changes that you'll lose if you leave without committing them.",
  },
  cancelDiscardChangesButton: {
    id: 'frontbucket.repository.source.discardChangesDialog.cancelButton',
    description:
      'Button to close a confirmation dialog and go back to editing the file without losing any changes made',
    defaultMessage: 'Cancel',
  },
  confirmDiscardChangesButton: {
    id: 'frontbucket.repository.source.discardChangesDialog.confirmButton',
    description:
      'Button to close a confirmation dialog and revert to a read-only file view, losing any un-committed changes previously made in edit mode',
    defaultMessage: 'Discard',
  },
  heading: {
    id: 'frontbucket.repository.source.discardChangesDialog.heading',
    description:
      'Header text in a confirmation dialog explaining that any changes just made to a file will be lost upon clicking the "Confirm" button',
    defaultMessage: 'Discarding your changes',
  },
});
